/* eslint-disable */
import MainCard from "components/MainCard";
import { useMemo } from "react";
import ECharts from 'echarts-for-react';
import useConfig from 'hooks/useConfig';
import { colors } from "data/data";

const chartDataInit = {
  tooltip: {
    trigger: 'item',
    formatter: '{b} : {c} ({d}%)'
  },
  legend: {
    orient: 'vertical',
    left: 'left',
    textStyle : {
      color : '#000'
    },
  },
  series: [
    {
      name: '',
      type: 'pie',
      // radius: '80%',
      radius: ['50%', '80%'],
      data: [],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
}

const pieColors = colors.map(c => c[0]);

export function PieChart({pieDatas, widthSize=480, legendPosition="left"}) {
  const { mode } = useConfig();
  const textColor = mode === "light" ? "#262626" : "#ffffff";

  const options = useMemo(() => {
    if (!pieDatas || pieDatas.length === 0) return chartDataInit;

    const total = pieDatas.reduce((sum, p) => sum + p.cnt, 0);

    // ⭐🔥 핵심: 전체 0일 때 처리
    if (total === 0) {
      return {
        tooltip: { show: false },

        legend: {
          orient: 'vertical',
          left: legendPosition,
          textStyle: {
            color: textColor,
          },
        },

        series: [
          {
            type: 'pie',
            radius: ['65%', '85%'],
            center: ['50%', '50%'],
            data: [
              {
                value: 1,
                name: 'empty',
                itemStyle: { color: '#e0e0e0' }
              }
            ],
            label: {
              show: true,
              position: 'center',
              formatter: 'empty',
              color: textColor,
              fontSize: 14,
              fontWeight: 'bold'
            },
            labelLine: { show: false }
          }
        ]
      };
    }

    return {
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)'
      },

      legend: {
        orient: 'vertical',
        left: legendPosition,
        textStyle: {
          color: textColor,
        },
      },

      color: colors.map(c => c[0]),   // ⭐ 라인차트와 색 통일

      graphic: [
        {
          type: 'text',
          left: 'center',
          top: '45%',
          style: {
            text: total === 0 ? 'No Data' : '',
            // text: total === 0 ? 'No Data' : total,
            fill: textColor,
            fontSize: 26,
            fontWeight: 'bold',
            textAlign: 'center'
          }
        },
        // {
        //   type: 'text',
        //   left: 'center',
        //   top: '58%',
        //   style: {
        //     // text: 'Total',
        //     fill: textColor,
        //     fontSize: 12,
        //     textAlign: 'center'
        //   }
        // }
      ],

      series: [
        {
          type: 'pie',
          radius: ['65%', '85%'],   // ⭐ 얇은 도넛
          center: ['50%', '50%'],
          avoidLabelOverlap: false,

          itemStyle: {
            borderRadius: 8,
            borderColor: 'transparent',
            borderWidth: 4
          },

          label: { show: false },
          labelLine: { show: false },

          data: pieDatas.map((pie, idx) => ({
            value: pie.cnt,
            // value: pie.cnt === 0 ? 1 : pie.cnt,
            name: pie.title,
            link: pie.link,
            itemStyle: {
              color: colors[idx % colors.length][0]
            }
          })),

          emphasis: {
            scale: true,
            scaleSize: 8,
            itemStyle: {
              shadowBlur: 20,
              shadowColor: 'rgba(0,0,0,0.3)'
            }
          }
        }
      ]
    };
  }, [pieDatas, mode, legendPosition]);

  // 클릭 이벤트 핸들러
  const onChartClick = (params) => {
    const link = params.data?.link;
    if (!link) return;   // ✅ 링크 없으면 아무 동작 안 함

    window.location.href = link;
  };

  if (!pieDatas?.length) return null;

  return (
    <div className="mixed-chart mixed-chart1">
      <MainCard content={false}>
          <ECharts
            style={{height:'unset'}}
            option={options}
            opts={{ renderer: 'svg', width: widthSize+'px', height: '270px' }}
            onEvents={{
              click: onChartClick,
            }}
          />
      </MainCard>
    </div>
  )
}

export default PieChart;
